import { render, staticRenderFns } from "./app-welcome.vue?vue&type=template&id=5d475c21"
import script from "./app-welcome.vue?vue&type=script&lang=js"
export * from "./app-welcome.vue?vue&type=script&lang=js"
import style0 from "./app-welcome.vue?vue&type=style&index=0&id=5d475c21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports